/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Student_0_AchievementInputs */

const en_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2008 U.S. Amateur Public Links Champion · Michigan State`)
};

const es_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campeón del U.S. Amateur Public Links 2008 · Michigan State`)
};

const de_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieger der U.S. Amateur Public Links 2008 · Michigan State`)
};

const zh_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Amateur Public Links 2008年冠军 · 密歇根州立大学`)
};

const ar_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بطل U.S. Amateur Public Links لعام 2008 · Michigan State`)
};

const fr_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Champion U.S. Amateur Public Links 2008 · Michigan State`)
};

const vi_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vô địch U.S. Amateur Public Links 2008 · Michigan State`)
};

const sw_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bingwa wa U.S. Amateur Public Links 2008 · Michigan State`)
};

const th_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แชมป์ U.S. Amateur Public Links ปี 2008 · Michigan State`)
};

const bs_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šampion U.S. Amateur Public Links 2008. · Michigan State`)
};

const ja_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2008年 全米アマチュア・パブリックリンクス優勝 · ミシガン州立大学`)
};

const ko_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2008 U.S. Amateur Public Links 챔피언 · 미시간 주립대학교`)
};

const pt_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campeão do U.S. Amateur Public Links 2008 · Michigan State`)
};

const it_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campione U.S. Amateur Public Links 2008 · Michigan State`)
};

const sv_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinnare av U.S. Amateur Public Links 2008 · Michigan State`)
};

const nl_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winnaar U.S. Amateur Public Links 2008 · Michigan State`)
};

const da_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinder af U.S. Amateur Public Links 2008 · Michigan State`)
};

const nb_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinner av U.S. Amateur Public Links 2008 · Michigan State`)
};

const fi_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoden 2008 U.S. Amateur Public Links -mestari · Michigan State`)
};

const pl_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistrz U.S. Amateur Public Links 2008 · Michigan State`)
};

const ru_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чемпион U.S. Amateur Public Links 2008 · Michigan State`)
};

const tr_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2008 U.S. Amateur Public Links Şampiyonu · Michigan State`)
};

const hi_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2008 U.S. Amateur Public Links चैंपियन · Michigan State`)
};

const id_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara U.S. Amateur Public Links 2008 · Michigan State`)
};

const ms_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara U.S. Amateur Public Links 2008 · Michigan State`)
};

const cs_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vítěz U.S. Amateur Public Links 2008 · Michigan State`)
};

const el_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πρωταθλητής U.S. Amateur Public Links 2008 · Michigan State`)
};

const he_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אלוף U.S. Amateur Public Links 2008 · Michigan State`)
};

const af_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2008 U.S. Amateur Public Links-kampioen · Michigan State`)
};

const hu_about_content_student_0_achievement = /** @type {(inputs: About_Content_Student_0_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2008-as U.S. Amateur Public Links-bajnok · Michigan State`)
};

/**
* | output |
* | --- |
* | "2008 U.S. Amateur Public Links Champion · Michigan State" |
*
* @param {About_Content_Student_0_AchievementInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_student_0_achievement = /** @type {((inputs?: About_Content_Student_0_AchievementInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Student_0_AchievementInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_student_0_achievement(inputs)
	if (locale === "de") return de_about_content_student_0_achievement(inputs)
	if (locale === "zh") return zh_about_content_student_0_achievement(inputs)
	if (locale === "ar") return ar_about_content_student_0_achievement(inputs)
	if (locale === "fr") return fr_about_content_student_0_achievement(inputs)
	if (locale === "vi") return vi_about_content_student_0_achievement(inputs)
	if (locale === "sw") return sw_about_content_student_0_achievement(inputs)
	if (locale === "th") return th_about_content_student_0_achievement(inputs)
	if (locale === "bs") return bs_about_content_student_0_achievement(inputs)
	if (locale === "ja") return ja_about_content_student_0_achievement(inputs)
	if (locale === "ko") return ko_about_content_student_0_achievement(inputs)
	if (locale === "pt") return pt_about_content_student_0_achievement(inputs)
	if (locale === "it") return it_about_content_student_0_achievement(inputs)
	if (locale === "sv") return sv_about_content_student_0_achievement(inputs)
	if (locale === "nl") return nl_about_content_student_0_achievement(inputs)
	if (locale === "da") return da_about_content_student_0_achievement(inputs)
	if (locale === "nb") return nb_about_content_student_0_achievement(inputs)
	if (locale === "fi") return fi_about_content_student_0_achievement(inputs)
	if (locale === "pl") return pl_about_content_student_0_achievement(inputs)
	if (locale === "ru") return ru_about_content_student_0_achievement(inputs)
	if (locale === "tr") return tr_about_content_student_0_achievement(inputs)
	if (locale === "hi") return hi_about_content_student_0_achievement(inputs)
	if (locale === "id") return id_about_content_student_0_achievement(inputs)
	if (locale === "ms") return ms_about_content_student_0_achievement(inputs)
	if (locale === "cs") return cs_about_content_student_0_achievement(inputs)
	if (locale === "el") return el_about_content_student_0_achievement(inputs)
	if (locale === "he") return he_about_content_student_0_achievement(inputs)
	if (locale === "af") return af_about_content_student_0_achievement(inputs)
	if (locale === "hu") return hu_about_content_student_0_achievement(inputs)
	return en_about_content_student_0_achievement(inputs)
});